module.exports = __webpack_public_path__ + "img/jing3.13b0b271.jpg";